/** Contact configuration required before public launch. Shared by UI and CLI. */
export const contactFields = Object.freeze([
  'VITE_CALLBACK_NUMBER',
  'VITE_CONTACT_EMAIL',
  'VITE_PRIVACY_EMAIL',
  'VITE_MAILING_ADDRESS',
  'VITE_LEGAL_ENTITY',
])

export function unsetContactFields(env) {
  return contactFields.filter(key => typeof env[key] !== 'string' || !env[key].trim())
}
